const mongoose = require("mongoose");
const Schema = mongoose.Schema;

const citySchema = new Schema(
    {
        Description: {
            type: String,
            required: true,
        },
        DescriptionRu: {
            type: String,
        },
        Ref: {
            type: String,
            required: true,
            index: true, // Индекс добавлен здесь
        },
        Area: {
            type: String,
            required: true,
            index: true, // Индекс добавлен здесь
        },
    },
    { timestamps: true } // Включение времени создания и обновления документа
);

module.exports = mongoose.model("City", citySchema);
